// tslint:disable

import axios from 'axios';
import { get } from 'lodash';
import * as React from 'react';
import { DatepickerField } from '../../components/fields/datepicker.field';
import { InputField } from '../../components/fields/input.field';
import { IriField } from '../../components/fields/iri.field';
import { JsonField } from '../../components/fields/json.field';
import { MediaItemField } from '../../components/fields/media-item.field';
import { Field, FormLib } from '../../components/libs/form.lib';
import { ListResourceLoader } from '../../components/libs/list-resource-loader';
import { ListLib } from '../../components/libs/list.lib';
import { ResourceLoader } from '../../components/libs/resource-loader';
import { DefaultSave } from '../../components/libs/updaters/default-save';
import { Validators } from '../../components/libs/Validators';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { CardPresenter } from '../../components/structurals/presenters/card.presenter';
import { IriPresenter } from '../../components/structurals/presenters/iri-presenter';
import { ResourceModal } from '../../components/structurals/resource-modal';
import { ToggleBoxComponent } from '../../components/structurals/toggle-box.component';
import { Environment } from '../../environment/environment';

export class DefaultCompany extends React.Component<any, any> {
    public hasEmitted: any = {};
    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);

    public async saveForm(form: FormLib): Promise<any> {
        this.executor.updateForm(form);
        await this.executor.exec();
    }

    handleEntityFieldFetched(form: FormLib, field: any, entity: string) {
        if (!this.hasEmitted.hasOwnProperty(entity)) {
            (form.fields[entity] as Field).setValue(get(field, 'value.@id'));
            this.hasEmitted[entity] = false;
        }
    }

    handlePersonCompanyCreated(pc: any, list: ListLib) {
        list.refetch();
    }

    async handlePersonCompanyDelete(item: any, list: ListLib) {
        list.isLoading$.next(true);
        try {
            await axios.delete(`${Environment.get('api.base')}${get(item, '@id')}`, {withCredentials: true});
        }
        catch (err) {
            alert(err.message);
        }
        finally {
            list.isLoading$.next(false);
            list.refetch();
        }
    }

    render() {
        return (
            <div>
                <ResourceLoader entity="company" entityId={this.props.ENTITY_ID} render={(form: FormLib) =>
                    <div className="row">
                        <LoaderComponent isLoading$={this.executor.loading$}/>

                        <div className="col-xs-12">
                            <div id="page-title">
                                <h2>Update company details</h2>
                            </div>
                        </div>

                        <div className="col-xs-12 col-md-9">
                            <ToggleBoxComponent title="General informations" alwaysOpen={true} preIcon="fa-building">
                                <div className="row">
                                    <div className="col-xs-12">

                                        <InputField
                                            field={form.fields.name}
                                            validators={[Validators.required('Required')]}/>

                                        <InputField
                                            field={form.fields.abtaNumber}/>


                                        <InputField field={form.fields.address}/>

                                        {form.fields.city && <IriField
                                            field={form.fields.city}
                                            defaultAll={true}
                                            itemRender={(item: any) => item.title}
                                            onFetched={(field: Field) => this.handleEntityFieldFetched(form, field, 'city')}/>}

                                        <InputField field={form.fields.postCode}/>

                                        <InputField
                                            placeholder="http://www.your-company.co.uk"
                                            field={form.fields.website}
                                            validators={[Validators.isWebsite('Invalid website address')]}
                                        />

                                        <InputField
                                            placeholder="your@email.co.uk"
                                            field={form.fields.email}
                                            validators={[Validators.isEmail('Invalid email address')]}/>

                                        <InputField
                                            field={form.fields.phone}
                                            validators={[Validators.isPhoneNumber('Required')]}/>

                                        <JsonField
                                            title={'Social links'}
                                            schema={{
                                                facebook: (schemaField: Field) => <InputField field={schemaField}/>,
                                                instagram: (schemaField: Field) => <InputField field={schemaField}/>,
                                                youtube: (schemaField: Field) => <InputField field={schemaField}/>,
                                                twitter: (schemaField: Field) => <InputField field={schemaField}/>
                                            }}
                                            field={form.fields.socialLinks}
                                        />
                                    </div>
                                </div>
                            </ToggleBoxComponent>

                            <ToggleBoxComponent title="Connected persons">

                                <ListResourceLoader
                                    entity="person-company"
                                    forceQuery={{company: this.props.ENTITY_ID}}
                                    render={(list: ListLib) => <div className="w-100">
                                        <LoaderComponent isLoading$={list.isLoading$}/>

                                        <ResourceModal
                                            entity="person-company"
                                            entityId="create"
                                            config={{company: this.props.ENTITY_ID}}
                                            onCreateSuccessful={(value: any) => this.handlePersonCompanyCreated(value, list)}
                                            title={<div><i className="fa fa-plus"/> Add new person</div>}/>

                                        <div className="row pt-3">
                                            <CardPresenter
                                                items={list.member}
                                                onDeleteClick={(item: any) => this.handlePersonCompanyDelete(item, list)}
                                                cover={(item: any) => <div>
                                                    <IriPresenter
                                                        // EZ ÍGY KSÉŐBB NEM LESZ JÓ! CSAK STRICT IRI
                                                        iri={get(item, 'person.@id')}
                                                        //path='avatar.images.120_90'
                                                        render={(src: any) => <IriPresenter iri={get(src, 'avatar.@id')} render={(image: any) => <img className="img-bordered border-default img-circle member-person-img" src={get(image, 'images.300_300')}/>}/>}/>
                                                </div>}
                                                description={(item: any) => <IriPresenter iri={get(item, 'job.@id')} render={(job: any) => get(job, 'title')}/>}
                                                title={(item: any) => <IriPresenter iri={get(item, 'person.@id')} render={(person: any) => `${get(person, 'firstName')} ${get(person, 'surName')}`}/>}/>
                                        </div>

                                    </div>}/>

                            </ToggleBoxComponent>
                        </div>

                        <div className="col-xs-12 col-md-3">
                            <ToggleBoxComponent title="Logo">
                                <MediaItemField
                                    field={form.fields.logo}
                                />
                            </ToggleBoxComponent>

                            <ToggleBoxComponent title="Properties">
                                <IriField
                                    className="col-xs-12"
                                    defaultAll={true}
                                    field={form.fields.type}
                                />

                                <IriField
                                    className="col-xs-12"
                                    field={form.fields.businessType}
                                    defaultAll={true}
                                    onFetched={(field: Field) => this.handleEntityFieldFetched(form, field, 'businessType')}
                                />

                                <IriField
                                    className="col-xs-12"
                                    defaultAll={true}
                                    field={form.fields.turnover}
                                />

                                <DatepickerField
                                    className="col-xs-12"
                                    disabled={true}
                                    field={form.fields.lastPaymentDate}/>


                                <DatepickerField
                                    className="col-xs-12"
                                    disabled={true}
                                    field={form.fields.createdAt}/>

                                <DatepickerField
                                    className="col-xs-12"
                                    disabled={true}
                                    field={form.fields.updatedAt}/>

                                <DatepickerField
                                    className="col-xs-12"
                                    disabled={true}
                                    field={form.fields.deletedAt}/>

                            </ToggleBoxComponent>
                        </div>

                        <div className="col-xs-12">
                            <button className="btn btn-primary pull-left" onClick={() => this.saveForm(form)}>Save
                            </button>
                        </div>
                    </div>

                }/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/__templates/details/default.company.tsx